import React from 'react';

const Impressum = () => {
    return (
        <main className="flex flex-col bg-zinc-900 text-zinc-200">
            {/* Impressum Section */}
            <section className="w-full py-12 md:py-24 lg:py-32">
                <div className="container px-4 md:px-6 mx-auto">
                    <div className="flex flex-col items-center space-y-8 text-center">
                        <h1 className="text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl lg:text-6xl">
                            Impressum
                        </h1>
                        <div className="w-full max-w-4xl text-left space-y-6">
                            {/* Nowocode UG Section */}
                            <div className="p-6 border-b border-gray-700">
                                <h2 className="text-2xl font-semibold mb-4">
                                    Nowocode UG (haftungsbeschränkt)
                                </h2>
                                <p>
                                    <strong>Adresse:</strong>
                                    <br /> Agricolastraße 8
                                    <br /> 38678 Clausthal-Zellerfeld
                                </p>
                                <p className="mt-2">
                                    <strong>Vertreten durch:</strong>
                                    <br /> Armin Nowosad
                                </p>
                                <p className="mt-2">
                                    <strong>Handelsregistereintrag:</strong>
                                    <br /> Amtsgericht Braunschweig
                                    <br /> Registernummer: HRB 210613
                                </p>
                                <p className="mt-2">
                                    <strong>Umsatzsteuer-Identifikationsnummer (USt-ID):</strong>
                                    <br /> DE123456789
                                </p>
                                <p className="mt-2">
                                    <strong>Kontakt:</strong>
                                    <br /> Telefon: <p className="hover:text-green-400 underline">00000000</p>
                                    <br /> E-Mail: <a href="mailto:info@nowocode.de" className="hover:text-green-400 underline">info@nowocode.de</a>
                                </p>
                            </div>

                            {/* SAVEUP24 Comparison Portal UG Section */}
                            <div className="p-6 border-b border-gray-700">
                                <h2 className="text-2xl font-semibold mb-4">
                                    SAVEUP24 Vergleichs Portal UG (haftungsbeschränkt)
                                </h2>
                                <p>
                                    <strong>Adresse:</strong>
                                    <br /> Agricolastraße 8
                                    <br /> 38678 Clausthal-Zellerfeld
                                </p>
                                <p className="mt-2">
                                    <strong>Vertreten durch:</strong>
                                    <br /> Phillip Dimsat
                                </p>
                                <p className="mt-2">
                                    <strong>Kontakt:</strong>
                                    <br /> Telefon: <a href="tel:+4953292349988" className="hover:text-green-400 underline">+49 (0) 5329-2349988</a>
                                    <br /> E-Mail: <a href="mailto:impressum@saveup24.de" className="hover:text-green-400 underline">impressum@saveup24.de</a>
                                </p>
                                <p className="mt-2">
                                    <strong>Handelsregistereintrag:</strong>
                                    <br /> Amtsgericht Braunschweig
                                    <br /> Registernummer: HRB 209835
                                </p>
                                <p className="mt-2">
                                    <strong>Steuernummer:</strong>
                                    <br /> 21/208/57304 Finanzamt Goslar
                                </p>
                                <p className="mt-2">
                                    <strong>Umsatzsteuer-Identifikationsnummer (USt-ID):</strong>
                                    <br /> DE987654321
                                </p>
                            </div>

                            {/* Gemeinsames Projekt Section */}
                            <div className="p-6">
                                <h2 className="text-2xl font-semibold mb-4">
                                    Gemeinsames Projekt: Managed Database Services cloudtal
                                </h2>
                                <p className="mb-4">
                                    Dieses Projekt wird gemeinsam betrieben von:
                                </p>
                                <ul className="list-disc list-inside mb-4 space-y-2">
                                    <li>Nowocode UG (haftungsbeschränkt), vertreten durch Armin Nowosad</li>
                                    <li>SAVEUP24 Vergleichs Portal UG (haftungsbeschränkt), vertreten durch Phillip Dimsat</li>
                                </ul>
                                <p className="mb-4">
                                    <strong>Verantwortlich für den Inhalt gemäß § 55 Abs. 2 RStV:</strong>
                                </p>
                                <ul className="list-disc list-inside mb-4 space-y-2">
                                    <li>Nowocode UG (haftungsbeschränkt), vertreten durch Armin Nowosad</li>
                                    <li>SAVEUP24 Vergleichs Portal UG (haftungsbeschränkt), vertreten durch Phillip Dimsat</li>
                                </ul>
                                <p>
                                    Für Anfragen zu diesem Projekt kontaktieren Sie uns bitte über die oben angegebenen Kontaktdaten.
                                </p>
                            </div>

                            {/* Weitere rechtliche Hinweise */}
                            <div className="p-6">
                                <h2 className="text-2xl font-semibold mb-4">
                                    Haftungsausschluss
                                </h2>
                                <p className="mb-4">
                                    <strong>Haftung für Inhalte</strong>
                                    <br /> Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                                </p>
                                <p className="mb-4">
                                    <strong>Haftung für Links</strong>
                                    <br /> Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                                </p>
                                <p className="mb-4">
                                    <strong>Urheberrecht</strong>
                                    <br /> Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                                </p>
                            </div>

                            {/* Datenschutz */}
                            <div className="p-6">
                                <h2 className="text-2xl font-semibold mb-4">
                                    Datenschutzerklärung
                                </h2>
                                <p>
                                    Unsere <a href="/datenschutz" className="hover:text-green-400 underline">Datenschutzerklärung</a> finden Sie hier.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Impressum;
